import React from "react";
import "./Profile.css";
import Loading from "../PrivacyPolicy/Loading";
import { useUserData } from "../../store/UserData";
import { useTranslation } from "react-i18next";

const CourseCard = () => {
  const { profile, loading, error } = useUserData();
  const { t } = useTranslation();
  if (loading) return <h2 className="text-center text-gray-700"><Loading /></h2>;
  if (error) return <p className="text-center text-red-500">{error}</p>;
  if (profile?.courseRegister?.length === 0) {
    return <p className="text-center text-gray-600">{t('profile.no-courses')}</p>;
  }

  return (
    <div className=" mx-auto p-4">

      {/* Course Grid */}
      <div className="grid grid-cols-1 gap-6 course-cards">
        {profile?.courseRegister.map((course, index) => (
          <div key={index} className="bg-gray-100 shadow-md rounded-lg p-4 row justify-content-between align-items-center">
            <div className="col-lg-9 row">
              {/* Course Image */}

              <img
                src={course?.course.image || "https://via.placeholder.com/150"}
                alt={course?.course.title}
                className="w-full p-0 col-md-3" style={{ objectFit: "cover" }}
              />

              {/* Course Title */}
              <div className="col-md-8">
                <h6 className="  ">
                  {course?.course?.title}
                </h6>

                {/* Course Subject */}
                <p className="b">{course?.course?.subject.title}</p>
                <p className="b">{course?.created_at}</p>
              </div>

            </div>
            <p className=" course-btn col-lg-3">
              {course?.price} {course?.currency}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseCard;
